import { motion } from "framer-motion";
import { TEST_IDS } from "@/constants/testIds";
import { useT } from "@/i18n/LanguageContext";

export const WhyChoose = () => {
  const { t } = useT();
  const points = t("why.points");

  return (
    <section
      id="why"
      data-testid={TEST_IDS.why.root}
      className="relative py-28 md:py-40 bg-soft"
    >
      <div className="container-luxe">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-[11px] tracking-[0.4em] text-gold">
              {t("why.index")}
            </span>
            <div className="h-px w-12 bg-gold" />
            <span className="overline">{t("why.overline")}</span>
          </div>
          <h2
            data-testid={TEST_IDS.why.heading}
            className="h-display text-4xl md:text-5xl lg:text-6xl text-ink text-balance"
          >
            {t("why.title1")}
            <br />
            <span className="italic">{t("why.title2")}</span>
          </h2>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {points.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: i * 0.06 }}
              className="group bg-white p-8 md:p-10 lg:p-12 hover:bg-white transition-colors duration-500 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 h-px w-0 bg-gold group-hover:w-full transition-all duration-700" />
              <div className="flex items-center justify-between mb-6">
                <span className="font-mono text-[11px] tracking-[0.4em] text-muted_text">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display italic text-sm text-gold">
                  Coumba Kandji
                </span>
              </div>
              <h3 className="font-display text-2xl md:text-[1.6rem] text-ink leading-tight mb-4">
                {p.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted_text font-light">
                {p.body}
              </p>
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: points.length * 0.06 }}
            className="bg-ink text-white p-8 md:p-10 lg:p-12 flex flex-col justify-between"
          >
            <span className="font-mono text-[11px] tracking-[0.4em] text-gold_soft">
              {t("why.promise")}
            </span>
            <div className="mt-10">
              <h3 className="font-display text-2xl md:text-[1.7rem] leading-tight">
                {t("why.promiseText")}
              </h3>
              <button
                data-testid="why-cta-inquiry"
                onClick={() =>
                  document
                    .getElementById("contact")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="mt-8 inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.32em] text-white border-b border-gold pb-2 hover:gap-5 transition-all duration-500"
              >
                {t("why.cta")}
                <span>→</span>
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
